/* eslint-disable no-unused-vars */
export interface ImageProps {
  id: number;
  src: string;
  height?: string;
  width?: string;
  blurDataUrl?: string;
  alt?: string;
  name?: string;
  recordId?: string;
}

export interface SharedModalProps {
  index: number;
  images?: ImageProps[];
  currentPhoto?: ImageProps;
  changePhotoId: (newVal: number) => void;
  closeModal: () => void;
  navigation: boolean;
  direction?: number;
  showAltLabel?: boolean;
}
